import create from 'zustand';

const NO_ACKNOWLEDGEMENTS = [];

/**
 * Acknowledgements survive the hand-offs blend flows make mid-action - route
 * redirects and stacked MHS panels alike - which a component-local Set would not.
 *
 * Safe to carry across a hand-off because the key fingerprints the exact values
 * acknowledged (`buildBlendCheckKey`), so any change to either batch re-arms the
 * gate, and only the most recent key is kept, so nothing leaks into a later action.
 */
const useBlendAcknowledgementStore = create(set => ({
  // { [checkKey]: acknowledged attribute keys }
  acknowledged: {},

  acknowledge: (checkKey, attributeKey) => {
    if (!checkKey || !attributeKey) {
      return;
    }

    set(state => {
      const current = state.acknowledged[checkKey] ?? NO_ACKNOWLEDGEMENTS;

      if (current.includes(attributeKey)) {
        return state;
      }

      // Replace rather than merge: only the action in progress is ever relevant.
      return { acknowledged: { [checkKey]: [...current, attributeKey] } };
    });
  },
}));

export { NO_ACKNOWLEDGEMENTS };
export default useBlendAcknowledgementStore;
